import { Link } from "react-router-dom";
import { articleList } from "@/mocks/articles";

export default function ArticleGrid() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-article-line"></i>
            <span className="whitespace-nowrap">SEO Resource Hub</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Vigorbuy Spreadsheet <span className="text-primary-500">Guides & Resources</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Dive into our collection of in-depth guides covering everything from beginner tutorials and safety tips to expert shopping strategies and category deep dives.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer no-underline"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={article.cardImageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium border border-background-200/50">
                    <i className="ri-book-open-line text-primary-500"></i>
                    <span className="whitespace-nowrap">{article.category}</span>
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}</span>
                  <span className="mx-1">·</span>
                  <i className="ri-calendar-line"></i>
                  <span>Aug 2026</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.subtitle}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-primary-500 text-sm font-medium">
                  <span className="whitespace-nowrap">Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}